import React, { useState } from 'react';

import { LogInFirstStep } from './components/LogInFirstStep';
import { LogInSecondStep } from './components/LogInSecondStep';

import Background from '../../assets/second_background.png';

import './signIn.scss';

const SignIn = () => {
  const [showSecondScreen, setShowSecondScreen] = useState(false);

  return (
    <div className="sign-in-container">
      <img src={Background} alt="background" className="background" />

      {!showSecondScreen ? (
        <LogInFirstStep setShowSecondScreen={setShowSecondScreen} />
      ) : (
        <LogInSecondStep setShowSecondScreen={setShowSecondScreen} />
      )}
    </div>
  );
};

export default SignIn;
